export interface SecuritySettings {
  waitingRoomEnabled?: boolean;
  waitForHost?: boolean;
  allowScreenShare?: 'hosts_only' | 'everyone';
  pinCode?: string;
  e2eeLocalConfigured?: boolean;
  accessPolicy?: 'invitation' | 'org_members' | 'public';
  dtlsVersions?: string[];
}

/** Client configuration only: it is not proof of server enforcement. */
export function securityOverviewRows(settings?: SecuritySettings): Array<[string, string]> {
  const configured = (value: boolean | undefined) => value === undefined ? 'Indisponibilă' : value ? 'Activată' : 'Dezactivată';
  return [
    ['Parolă / PIN', typeof settings?.pinCode === 'string' ? (settings.pinCode.trim() ? 'Setat' : 'Nesetat') : 'Indisponibil'],
    ['Sala de așteptare', configured(settings?.waitingRoomEnabled)],
    ['Așteaptă gazda', configured(settings?.waitForHost)],
    ['Partajarea ecranului', settings?.allowScreenShare === 'hosts_only' ? 'Doar gazda' : settings?.allowScreenShare === 'everyone' ? 'Toți participanții' : 'Indisponibilă'],
    ['Criptare media', settings?.dtlsVersions?.length ? `DTLS-SRTP · ${settings.dtlsVersions.join(' / ')}` : 'DTLS-SRTP · versiune indisponibilă'],
    ['Criptare end-to-end', settings?.e2eeLocalConfigured ? 'E2EE activă pe acest dispozitiv' : 'E2EE inactivă sau indisponibilă'],
    ['Identitate și acces', settings?.accessPolicy === 'invitation' ? 'Doar cu invitație' : settings?.accessPolicy === 'org_members' ? 'Membrii organizației' : settings?.accessPolicy === 'public' ? 'Acces public' : 'Indisponibil'],
  ];
}
